import { activeModule } from "../providers/active-module";
import * as CoreComponents from "./src/entities";
import * as FourTimeComponents from "../4time/components";
import * as IrsKomComponents from "../IrsKom/components";
import * as Parhato2Components from "../parhato2/components";

const modulesComponents: Record<string, any> = {
  "4TIME": FourTimeComponents,
  IRSKOM: IrsKomComponents,
  PARHATO2: Parhato2Components,
};

let Components = CoreComponents;

const moduleName = activeModule;
if (modulesComponents[moduleName]) {
  Components = { ...CoreComponents, ...modulesComponents[moduleName].Components };
}

export const {
  OrderForm,
  MainPageProduct,
  NewListViewProduct,
  BackButton,
  ProductsSearchBarHeader,
  Tabs,
  ChoosePaymentMethod,
  CartProductCard,
  CartUnavailableProduct,
  Payment,
} = Components;
